export default {
    projects: [],
    projectFilters: {
        realStateAgencie:"",
        project:"",
        filteredProjects:[],
    },
    webhooks: [],
    webhooks_records: [],
}